export const KP_WORKER_URL = "https://kp.metrpiva.com";
export const REZKA_WORKER_URL = "https://rezka.metrpiva.com";
export const VOIDBOOST_URL = "https://voidboost.net";
